import { generateGPXContent } from './generateGPXContent'

export const downloadGPX = (pathCoords: any, itinerarySequence: any) => {

  const gpxContent = generateGPXContent(pathCoords, itinerarySequence); // 

  const blob = new Blob([gpxContent], { type: 'application/gpx+xml' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = 'ruta.gpx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}



